import React, { useState, useEffect } from "react";
import { ChevronDown } from "lucide-react";
import { useChild } from "../../ContextAPI/ChildContext";
import { getRequest, postRequest } from "../../services";
import { message } from "antd";

const FeedBack = () => {

    const [buttons, setButtons] = useState([
        { label: "teacher", clicked: true },
        { label: "class", clicked: false },
        { label: "school", clicked: false },
    ]);
    const { selectedChildId, usersChild } = useChild();
    console.log("usersChild",usersChild)
    
    const [selectedTeacher, setSelectedTeacher] = useState("");
    const [teacherList, setTeacherList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [description, setDescription] = useState("");
    const [submitting, setSubmitting] = useState(false);

    // Fetch teachers when selectedChildId changes
    useEffect(() => {
        const fetchTeachers = async () => {
            if (selectedChildId) {
                setLoading(true);
                try {
                    const response = await getRequest(`/api/Teacher/teacher-by-student-id?studentId=${selectedChildId}`);
                    if (response.data && Array.isArray(response.data)) {
                        setTeacherList(response.data);
                    } else {
                        setTeacherList([]);
                    }
                } catch (error) {
                    console.error("Error fetching teachers:", error);
                    setTeacherList([]);
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchTeachers();
    }, [selectedChildId]);

    const handleOptionSelect = (teacher) => {
        setSelectedTeacher(teacher.name);
    };

    const handleClick = (index) => {
        const newBtns = buttons.map((btn, idx) => ({
            ...btn,
            clicked: idx === index,
        }));
        setButtons(newBtns);
    };

    const handleSubmit = async () => {
        // Validate required fields
        if (!description.trim()) {
            message.warning("Please enter feedback description");
            return;
        }

        if (activeBtn.label === "teacher" && !selectedTeacher) {
            message.warning("Please select a teacher");
            return;
        }

        setSubmitting(true);
        try {
            // Get className from usersChild based on selectedChildId
            const selectedChild = usersChild?.find(child => child.id === selectedChildId);
            const className = selectedChild?.assignedClass?.className || "";
            const classId = selectedChild?.assignedClass?.classId || "";

            let campusName = "";
            
            // Get campus information if classId exists
            if (classId) {
                try {
                    // First get the campusId from class API
                    const classResponse = await getRequest(`/api/Class/Get/${classId}`);
                    if (classResponse.data?.success && classResponse.data?.data?.campusId) {
                        const campusId = classResponse.data.data.campusId;
                        
                        // Then get the campus name using campusId
                        const campusResponse = await getRequest(`/api/Campus/${campusId}`);
                        if (campusResponse.data?.name) {
                            campusName = campusResponse.data.name;
                        }
                    }
                } catch (error) {
                    console.error("Error fetching campus information:", error);
                    // Continue without campus name if there's an error
                }
            }

            const payload = {
                teacherName: selectedTeacher || "",
                className: className,
                description: description.trim(),
                type: activeBtn.label.charAt(0).toUpperCase() + activeBtn.label.slice(1),
                campusName: campusName
            };

            console.log("Submitting complaint payload:", payload);

            const response = await postRequest("/api/Complaint/AddComplaint", payload);
            
            if (response.status === 200) {
                message.success("Feedback submitted successfully!");
                // Reset form
                setDescription("");
                setSelectedTeacher("");
            } else {
                message.error("Failed to submit feedback. Please try again.");
            }
        } catch (error) {
            console.error("Error submitting feedback:", error);
            message.error("Error submitting feedback. Please try again.");
        } finally {
            setSubmitting(false);
        }
    };

    const activeBtn = buttons.find((btn) => btn.clicked === true);

    return (
        <div className="d-flex flex-column gap-2">
            <div className="d-flex align-items-center gap-3 my-3">
                {buttons.map((btn, index) => (
                    <button
                        className={`text-capitalize btn btn-sm py-2 px-3 ${btn.clicked ? "btn-primary" : "btn-secondary stylesUnSelcBtn"
                            }`}
                        key={index}
                        onClick={() => handleClick(index)}
                    >
                        {btn.label}
                    </button>
                ))}
            </div>

            {/* Dropdown for Teacher List when Teacher tab is active */}
            {activeBtn.label === "teacher" && (
                <div className="col-md-4 text-start">
                    <label htmlFor="teacherInput" className="weakform-text form-label">
                        Select Teacher
                    </label>
                    <div className="mb-3 d-flex">
                        <input
                            id="teacherInput"
                            type="text"
                            className="input-cx rounded-start ps-2"
                            value={selectedTeacher}
                            readOnly
                            placeholder={loading ? "Loading teachers..." : "Select a teacher"}
                        />
                        <button
                            className="drop-btn rounded-end"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            disabled={loading}
                        >
                            <ChevronDown className="icon-drop" />
                        </button>
                        <ul className="dropdown-menu">
                            {loading ? (
                                <li><span className="dropdown-item">Loading...</span></li>
                            ) : teacherList.length > 0 ? (
                                teacherList.map((teacher, index) => (
                                    <li key={index}>
                                        <button
                                            className="dropdown-item"
                                            type="button"
                                            onClick={() => handleOptionSelect(teacher)}
                                        >
                                            {teacher.name}
                                        </button>
                                    </li>
                                ))
                            ) : (
                                <li><span className="dropdown-item">No teachers found</span></li>
                            )}
                        </ul>
                    </div>
                </div>
            )}

            <textarea
                rows={4}
                className="form-control"
                placeholder={`Submit feedback for ${activeBtn.label}`}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
            ></textarea>

            <p className="d-flex justify-content-end">
                <button 
                    className="bg-main text-white btn btn-sm w-25 btn-primary"
                    onClick={handleSubmit}
                    disabled={submitting}
                >
                    {submitting ? "Submitting..." : "Submit"}
                </button>
            </p>
        </div >
    );
};

export default FeedBack;
